export const MULTI_PRODUCT = 'MULTI_PRODUCT';
export const VIDEO_PLAYER = 'VIDEO_PLAYER';
